import "./BookAConsultation.module.css";
import Header from "@/reusable_sections/Header";
import OnboardingFaq from "./sections/OnboardingFaq";
import Inquiry from "./sections/Inquiry";
import Footer from "@/reusable_sections/Footer";
import YourFirstVisit from "./sections/YourFirstVisit";
export default function BookAConsultationPage() {
  return <div>
      <Header />
      <Inquiry />
      <OnboardingFaq />
      <YourFirstVisit />
      <Footer />
    </div>;
}